import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=0142e0b4"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0142e0b4')) {
      api.createRecord('0142e0b4', component.options)
    } else {
      api.reload('0142e0b4', component.options)
    }
    module.hot.accept("./Deliveries.vue?vue&type=template&id=0142e0b4", function () {
      api.rerender('0142e0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/Deliveries.vue"
export default component.exports